import * as types from '../mutation-types';

const initialState = {
  forms: {
    operations: {},
    workPlanning: {},
    analysesSearch: {},
    printAnalyses: {},
    defaultLocations: {},
    customersLocations: {},
    specifications: {},
    analysesThermostatsSearch: {},
    stabilityTimePointExport: {},
  },
};

const forms = { ...initialState };

const getters = {
  forms: (state) => state.forms,
};

const actions = {
  updateForm({ commit }, { formKey, formData }) {
    commit(types.UPDATE_FORM, { formKey, formData });
  },
  resetForm({ commit }, formKey) {
    commit(types.RESET_FORM, formKey);
  },
  resetAllForms({ commit }) {
    Object.keys(forms.forms).forEach((key) => {
      commit(types.RESET_FORM, key);
    });
  },
};

const mutations = {
  [types.UPDATE_FORM](state, { formKey, formData }) {
    state.forms[formKey] = formData;
  },
  [types.RESET_FORM](state, formKey) {
    state.forms[formKey] = {};
  },
};

export default {
  state: forms,
  getters,
  actions,
  mutations,
};
